import { Component } from '@angular/core';

import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { scrollToTop } from '@gallaghercp/core-frontend';
import { throwError } from 'rxjs';
import { RegisterComponent } from '../register/register.component';

@Component({
    selector: 'core-reset-confirm',
    templateUrl: './reset-confirm.component.html',
    standalone: false,
})
export class ResetConfirmComponent extends RegisterComponent {
    token?: string;

    resetForm = new UntypedFormGroup({
        password: new UntypedFormControl('', [
            Validators.required,
            Validators.minLength(10),
            Validators.pattern(this.validPasswordPattern),
        ]),
        confirmPassword: new UntypedFormControl('', [
            Validators.required,
            Validators.minLength(10),
            Validators.pattern(this.validPasswordPattern),
        ]),
    });

    reset() {
        this.submitting = true;
        this.errorMessage = false;
        this.spinner.show('reset');

        const data = {
            password: this.resetForm.get('password')!.value,
            confirmation: this.resetForm.get('confirmPassword')!.value,
        };

        return this.subscriptions.push(
            this.api.post('password-reset/?auth_token=' + this.token, data).subscribe(
                () => {
                    scrollToTop(500);
                    this.spinner.hide('reset');
                    this.submitting = false;
                    this.successMessage = `Your account has been reset. Please <a href="/login">click here</a> to login`;
                    this.resetForm.reset();
                },
                error => {
                    scrollToTop(500);
                    this.spinner.hide('reset');
                    this.submitting = false;
                    this.errorMessage = `<p>Your reset attempt failed, please check the information you entered and try again.</p>
                                    <p>Error reference: ${error.headers.get('x-service-request-id')}</small></p>`;
                    return throwError(`Error Code: ${error.status}\nMessage: ${error.message}`);
                },
            ),
        );
    }

    override ngOnInit() {
        this.auth.validateAuthentication().subscribe(() => {
            if (this.auth.isAuthenticated()) {
                return this.client.navigateToHome();
            }
            this.auth.initialise().subscribe(() => {
                this.client.getAccessType().subscribe((type: any) => {
                    if (type !== 'individual' && type !== 'mixed') {
                        this.client.navigateToHome();
                    }
                });
            });
            this.route.paramMap.subscribe(params => {
                this.token = params.get('token') as string;
            });
            return false;
        });
    }
}
